import { useAuth } from '../../contexts/AuthContext';
import { useApp } from '../../contexts/AppContext';
import './HomepageView.css';

interface HomepageViewProps {
  config?: Record<string, unknown>;
}

export function HomepageView({ config: _config }: HomepageViewProps) {
  const { user, application } = useAuth();
  const { selectedProject, selectedUserGroup } = useApp();

  return (
    <div className="homepage-view">
      <div className="homepage-content">
        <div className="welcome-section">
          <h1 className="welcome-title">
            Welcome{user ? `, ${user._firstname || user._email}` : ''}!
          </h1>
          <p className="welcome-subtitle">
            You're connected to the DT Platform
          </p>
        </div>

        <div className="info-cards">
          {application && (
            <div className="info-card">
              <div className="card-icon">
                <i className="fas fa-cube"></i>
              </div>
              <div className="card-content">
                <h3>Application</h3>
                <p className="card-value">{application._name}</p>
                {application._description && (
                  <p className="card-description">{application._description}</p>
                )}
              </div>
            </div>
          )}

          {user && (
            <div className="info-card">
              <div className="card-icon">
                <i className="fas fa-user"></i>
              </div>
              <div className="card-content">
                <h3>User</h3>
                <p className="card-value">
                  {user._firstname} {user._lastname}
                </p>
                <p className="card-description">{user._email}</p>
              </div>
            </div>
          )}

          {selectedProject && (
            <div className="info-card">
              <div className="card-icon">
                <i className="fas fa-folder-open"></i>
              </div>
              <div className="card-content">
                <h3>Current Project</h3>
                <p className="card-value">{selectedProject._name}</p>
                {selectedProject._description && (
                  <p className="card-description">{selectedProject._description}</p>
                )}
              </div>
            </div>
          )}

          {selectedUserGroup && (
            <div className="info-card">
              <div className="card-icon">
                <i className="fas fa-users"></i>
              </div>
              <div className="card-content">
                <h3>User Group</h3>
                <p className="card-value">{selectedUserGroup._name}</p>
              </div>
            </div>
          )}
        </div>

        <div className="quick-actions">
          <h2>Quick Actions</h2>
          <div className="actions-grid">
            <a href="#/" className="action-card">
              <i className="fas fa-project-diagram"></i>
              <span>View Projects</span>
            </a>
            <a href="#/settings" className="action-card">
              <i className="fas fa-cog"></i>
              <span>Settings</span>
            </a>
            <a href="#/help" className="action-card">
              <i className="fas fa-question-circle"></i>
              <span>Help</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomepageView;

